var map = {
	"./CircleDownIcon.svg": 5483,
	"./adjust.svg": 38886,
	"./angle-down-small.svg": 6633,
	"./angle-left-small.svg": 26169,
	"./angle-right-small.svg": 75738,
	"./arrow-down-sprite.svg": 64668,
	"./arrow-down.svg": 52750,
	"./arrow-right-small.svg": 92821,
	"./attach-file.svg": 58761,
	"./bath-tub.svg": 25840,
	"./bathtub-type.svg": 95419,
	"./bell.svg": 46123,
	"./black-plus.svg": 76761,
	"./calendar.svg": 5863,
	"./charge.svg": 11761,
	"./chat-line.svg": 91297,
	"./chevron-left.svg": 45779,
	"./chevron-right.svg": 49245,
	"./circle-down.svg": 19969,
	"./circle-next.svg": 16381,
	"./clock.svg": 73643,
	"./close-primary.svg": 7474,
	"./close-white.svg": 36442,
	"./close.svg": 65011,
	"./cloud.svg": 84347,
	"./double-bed.svg": 77133,
	"./drop-down.svg": 86569,
	"./emailIcon.svg": 16493,
	"./expand.svg": 22788,
	"./eyes.svg": 39925,
	"./facebook-black.svg": 32251,
	"./facebook-icon.svg": 51827,
	"./facebook.svg": 69725,
	"./filterIcon.svg": 42224,
	"./full-screen-icon.svg": 50766,
	"./header-phone.svg": 42765,
	"./hotel-logo-mobile.svg": 8792,
	"./hotel-mystays-logo.svg": 38830,
	"./info-circle.svg": 70797,
	"./instagram-black.svg": 17067,
	"./instagram-icon.svg": 77828,
	"./instagram.svg": 97899,
	"./letter.svg": 37464,
	"./lighthouse.svg": 14230,
	"./line-black.svg": 55255,
	"./line-icon.svg": 91857,
	"./location-pin.svg": 48453,
	"./location.svg": 25519,
	"./logo.svg": 1291,
	"./map-search.svg": 18513,
	"./map.svg": 22000,
	"./marker-pin-04.svg": 54952,
	"./menu.svg": 68972,
	"./minus.svg": 78276,
	"./news-release.svg": 79780,
	"./onsen.svg": 70341,
	"./parkingSpaces.svg": 84787,
	"./phone.svg": 3241,
	"./photos-icon.svg": 982,
	"./plus.svg": 21828,
	"./point-1.svg": 61996,
	"./point-2.svg": 52028,
	"./point-3.svg": 10484,
	"./room.svg": 56904,
	"./shower-type.svg": 98832,
	"./slider-next.svg": 45298,
	"./slider-prev.svg": 60670,
	"./smoke.svg": 51417,
	"./spinner.svg": 75318,
	"./sprite-chat.svg": 82353,
	"./sprite-icon-web.svg": 41684,
	"./sprite-mail.svg": 64453,
	"./sprite-phone.svg": 92341,
	"./swimming-pool.svg": 47213,
	"./test.svg": 64239,
	"./toilet-type.svg": 96154,
	"./toilet.svg": 10472,
	"./twitter.svg": 4513,
	"./user.svg": 45813,
	"./white-circle-next.svg": 6039,
	"./wifi.svg": 67726,
	"./x-black.svg": 68423,
	"./x-icon.svg": 45158,
	"./youtube-black.svg": 57795,
	"./youtube-icon.svg": 12049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75245;